module.exports = __webpack_public_path__ + "img/company-active.c6ae0a44.svg";